import { render, staticRenderFns } from "./ProductBrochure.vue?vue&type=template&id=63bfec68&scoped=true"
import script from "./ProductBrochure.vue?vue&type=script&lang=js"
export * from "./ProductBrochure.vue?vue&type=script&lang=js"
import style0 from "./ProductBrochure.vue?vue&type=style&index=0&id=63bfec68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfec68",
  null
  
)

export default component.exports